import React, { useContext, useState } from 'react';
import './TopCabsRoutes.css';
import queryString from 'query-string';
import { TopRoutes, CabData, CabType } from '../../pages/runtime-typechecker';
import { formatDuration } from '../../utils/timeUtils';
import { Context } from '../../AppContext';
import { setDateAsDatePlusN, setPickupTime } from '../../utils/timeUtils';
import BPG from '../BPG/BPG';
import { CASE_CAB_CARD } from '../../constants/omniture';
import { useMediaQuery } from 'react-responsive';
import { extractTemplateTypeFromOmniUrlArgs } from '../../utils/stringUtils';
import { getAppEnv } from '../../../config/env';
import { getCmpFromUrl, isMobile, isWebView } from '../../utils/commonUtils';
import { yeildToMainThread } from '../../scheduler';
import { TEMPO_TRAVELLER } from '../../constants/miscellaneousConstants';
const isSSR = () => typeof window === 'undefined';
const env = getAppEnv();
const { PUBLIC_URL } = env.raw;

type TopCabRoutesProps = {
  h2: string;
  cityName: string;
  operatorName?: string;
  routeType: string;
  data: TopRoutes;
  noOfListings?: number;
  isMobileDevice?: boolean;
  carTypeName?: string;
  enableAnchorTags?: boolean;
  rydeEnabled?: boolean;
  isRydeHomePage?: boolean;
  reduceCssCalculations?: boolean;
};
const TopCabsRoutes = ({
  h2,
  // setWidget,
  cityName,
  operatorName,
  routeType,
  data,
  noOfListings = 10,
  carTypeName,
  enableAnchorTags = false,
  rydeEnabled = false,
  isRydeHomePage = false,
  reduceCssCalculations = true
}: // isMobileDevice
TopCabRoutesProps) => {
  const isMobileDevice = useMediaQuery({
    query: '(max-device-width: 768px)'
  });
  const { trackTemplateEvent, omniUrlArgs } = useContext(Context);
  const { cabTypes, cabs } = data;
  const [selectedCabType, setSelectedCabType] = useState<null | string>(
    cabTypes.length > 0 ? cabTypes[0].type : null
  );
  const templateType = extractTemplateTypeFromOmniUrlArgs(omniUrlArgs);
  const handleCabSelect = (cabType: null | string) => {
    yeildToMainThread(() => {
      setSelectedCabType(cabType);
    });
    trackTemplateEvent(
      ((): string => {
        if (
          templateType === 'Route_Car_Type_Template' ||
          templateType === 'City_Car_Type_Template'
        ) {
          return `Cab_SEO_Other_CabTypes_${cabType}_Select`;
        } else if (templateType === 'Operator_Template') {
          return `Cab_SEO_${operatorName}_${cabType}_Cab_Select`;
        } else {
          return `Cab_SEO_Top_Route_${routeType}_City_${cabType}_Cab_Select`;
        }
      })()
    );
  };

  const getCabTypeIcon = (cabType: string): string => {
    const iconMap = {
      HATCHBACK: 'hatchbackIcon',
      SEDAN: 'sedanIcon',
      SUV: 'suvIcon'
    };
    return iconMap[cabType];
  };

  const trackClick = (fromCity: string, toCity: string) => {
    trackTemplateEvent(
      ((): string => {
        if (
          templateType === 'Route_Car_Type_Template' ||
          templateType === 'City_Car_Type_Template'
        ) {
          return `Cab_SEO_Other_CabTypes_${fromCity}-${toCity}_${selectedCabType}_View_Cab_Click`;
        } else if (templateType === 'Operator_Template') {
          return `Cab_SEO_${operatorName}_${selectedCabType}_${fromCity}_${toCity}_View_Cab_Click`;
        } else {
          return `Cab_SEO_Top_Route_${routeType}_City_${selectedCabType}_View_Cab_Click`;
        }
      })()
    );
  };
  const getRedirectionUrl = (
    url: string | undefined,
    forwardDate: number | undefined
  ) => {
    if (!url) return;
    const cmp = getCmpFromUrl();
    const query = queryString.parseUrl(url).query;
    const fromCity = query['fromCity'];
    const toCity = query['toCity'];
    const redirectionUrl =
      !isSSR() && isWebView()
        ? `${setDateAsDatePlusN(
            `mmyt://react/?page=cabsListing&deeplink=true&to=${toCity}&from=${fromCity}&tripType=OW&startDate=21-08-2020&${omniUrlArgs}${CASE_CAB_CARD}`
          )}`
        : `${setPickupTime(
            setDateAsDatePlusN(url, 1, forwardDate)
          )}&${omniUrlArgs}${CASE_CAB_CARD}&cmp=${cmp}`;
    window.location = Object(redirectionUrl);
  };

  return (
    <section className={reduceCssCalculations ? `visibilityAuto` : ``}>
      <h2>{h2}</h2>
      <div className="makeRelative">
        <div className="cabTypeWrap">
          <div className="tapWrap">
            <p className="tabTypeTitleSmall">
              {`Select  ${
                operatorName ? operatorName + ' ' : ''
              }type to update price, included kms & extra fare`}
            </p>
            <div className="tabTypeTitle">
              <p className="headingText">
                {' '}
                {`Select ${operatorName ? operatorName + ' ' : ''}type`}
              </p>
              <p className="subHeadingText">
                To update price, included kms & extra fare
              </p>
            </div>
            <ul className="cabTap">
              {cabTypes.map((cabType: CabType, idx) => {
                return (
                  <li
                    onClick={() => handleCabSelect(cabType.type)}
                    key={cabType.type + routeType + idx}
                    className={selectedCabType === cabType.type ? 'active' : ''}
                  >
                    <span className="activeCheck"></span>
                    {rydeEnabled ? (
                      <img
                        className="rydeAssuredDesign"
                        src={`${PUBLIC_URL}/static/public/rydeNewtagV2.png`}
                      ></img>
                    ) : null}
                    <span
                      className={`cabSeoSprite ${getCabTypeIcon(
                        cabType.type
                      )} appendLeft10`}
                    ></span>
                    <span className="cabTabtext">{cabType.type}</span>
                    <span className="circleOuter">
                      <span className="circleInner"></span>
                    </span>
                  </li>
                );
              })}
            </ul>
          </div>
          <div className={`cabTypeDetails`}>
            <table
              style={{ width: '100%', border: '1px solid #cecece' }}
              className="noBorder"
            >
              {!isMobile() ? (
                <>
                  <thead>
                    <tr
                      style={{ width: '100%' }}
                      className="cabTypeHead noBorder"
                    >
                      <th style={{ width: '34%', textAlign: 'start' }}>
                        <span className="cabTypeCol">
                          {operatorName
                            ? `Top ${cityName} ${operatorName} Routes`
                            : `${
                                isRydeHomePage ? 'Ryde ' : ''
                              }Cabs ${routeType.toLowerCase()} ${cityName}`}
                        </span>
                      </th>
                      <th style={{ width: '27%' }}>
                        <span className="cabTypeCol">
                          Included kms & Extra fare
                        </span>
                      </th>
                      <th style={{ width: '36%' }}>
                        <span className="cabTypeCol appendRight30">
                          {' '}
                          {isRydeHomePage ? 'Ryde ' : ''}Cab Price
                        </span>
                      </th>
                      <th style={{ width: '' }}>
                        <span className="cabTypeCol viewDtl"> &nbsp;</span>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {selectedCabType &&
                      cabs[selectedCabType]
                        .filter((_, index) => {
                          return isSSR() ? true : index < noOfListings;
                        })
                        .map((item: CabData, index: number) => {
                          return (
                            <>
                              <tr
                                style={{ width: '100%' }}
                                key={index + routeType}
                                className={
                                  index === 0
                                    ? 'cabTypeRow noBdr'
                                    : 'cabTypeRow'
                                }
                              >
                                {/* <tr style={{width:"100%"}}> */}
                                <td
                                  style={{
                                    width: '40%',
                                    border: '1px solid #cecece'
                                  }}
                                >
                                  <div className="cabTypeCol">
                                    <p className="cabTypeRoute">
                                      {item.seoUrl ? (
                                        <a
                                          className={`${
                                            enableAnchorTags
                                              ? 'cabTypeRouteLinkHover'
                                              : 'pointerEventNone'
                                          } cabTypeRoute`}
                                          href={item.seoUrl}
                                        >
                                          {item.route}
                                        </a>
                                      ) : (
                                        <span className="cabTypeRoute">
                                          {item.route}
                                        </span>
                                      )}
                                    </p>
                                    <p className="cabTimeDis">
                                      {(() => {
                                        // if(carTypeName===TEMPO_TRAVELLER){
                                        //   return <>{item?.seat_count
                                        // ? `${item.seat_count} passengers | `
                                        // : ''}
                                        //   {item.ac_string?item.ac_string:''}
                                        // </>
                                        // }
                                        // else{
                                        return (
                                          <>
                                            {item?.oneway_distance_in_kms
                                              ? `${item.oneway_distance_in_kms} kms |`
                                              : ''}
                                            {item.oneway_duration_in_minutes
                                              ? formatDuration(
                                                  item.oneway_duration_in_minutes
                                                )
                                              : null}
                                          </>
                                        );
                                        // }
                                      })()}
                                    </p>
                                  </div>
                                </td>
                                <td
                                  style={{
                                    width: item.strike_off_amount
                                      ? '40%'
                                      : '40%',
                                    border: '1px solid #cecece'
                                  }}
                                >
                                  <div className="cabTypeCol">
                                    {item?.included_kms ? (
                                      <p className="cabTypeIncDis">
                                        {item.included_kms} kms included
                                      </p>
                                    ) : null}
                                    <p className="cabTypeFare">
                                      Extra fare ₹{item.per_km_charge}/km after{' '}
                                      {item.included_kms} kms
                                    </p>
                                  </div>
                                </td>
                                <td
                                  style={{
                                    width: item.strike_off_amount
                                      ? '18%'
                                      : '18%',
                                    border: '1px solid #cecece'
                                  }}
                                >
                                  <div className="cabTypeCol">
                                    <p className="cabTypePrice">
                                      ₹{item.total_amount}
                                      {item.strike_off_amount ? (
                                        <span className="appendLeft5 strikeOffPrice">
                                          ₹{item.strike_off_amount}
                                        </span>
                                      ) : null}
                                    </p>
                                    <p className="cabTypeOnwards">
                                      {item?.tolls_and_taxes_text}
                                    </p>
                                  </div>
                                </td>
                                <td
                                  style={{
                                    width: '15%',
                                    border: '1px solid #cecece'
                                  }}
                                >
                                  <div className="cabTypeCol">
                                    <a
                                      className="viewCabBtn"
                                      onClick={e => {
                                        e.preventDefault();
                                        if (
                                          item.sourceCity &&
                                          item.destinationCity
                                        ) {
                                          trackClick(
                                            item.sourceCity,
                                            item.destinationCity
                                          );
                                        }
                                        let forwardDate;
                                        if (carTypeName == TEMPO_TRAVELLER) {
                                          forwardDate = 1;
                                        }
                                        getRedirectionUrl(
                                          item.redirection_url,
                                          forwardDate
                                        );
                                      }}
                                      href={item.redirection_url}
                                    >
                                      {' '}
                                      VIEW CABS
                                    </a>
                                  </div>
                                </td>
                              </tr>
                              <tr>
                                {!isSSR() &&
                                item.best_price_guarantee_details ? (
                                  <td className="noBorder">
                                    <BPG
                                      bpgInfo={
                                        item.best_price_guarantee_details
                                      }
                                      isMobileDevice={false}
                                      fromCity={
                                        item.sourceCity ? item.sourceCity : ''
                                      }
                                      toCity={
                                        item.destinationCity
                                          ? item.destinationCity
                                          : ''
                                      }
                                    />
                                  </td>
                                ) : null}
                              </tr>
                            </>
                          );
                        })}
                  </tbody>
                </>
              ) : (
                <>
                  <thead>
                    <tr
                      style={{ width: '100%' }}
                      className="cabTypeHead noBorder"
                    >
                      <th style={{ width: '34%', textAlign: 'start' }}>
                        <span className="cabTypeCol">
                          {operatorName
                            ? `Top ${cityName} ${operatorName} Routes`
                            : `${
                                isRydeHomePage ? 'Ryde ' : ''
                              } Cabs ${routeType.toLowerCase()} ${cityName}`}
                        </span>
                      </th>
                      <th style={{ width: '27%' }}>
                        <span className="cabTypeCol">
                          Included kms & Extra fare
                        </span>
                      </th>
                      <th style={{ width: '36%' }}>
                        <span className="cabTypeCol">
                          {isRydeHomePage ? 'Ryde ' : ''} Cab Price
                        </span>
                      </th>
                      <th style={{ width: '' }}>
                        <span className="cabTypeCol viewDtl"> &nbsp;</span>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {selectedCabType &&
                      cabs[selectedCabType]
                        .filter((_, index) => {
                          return isSSR() ? true : index < noOfListings;
                        })
                        .map((item: CabData, index: number) => {
                          return (
                            <>
                              <tr
                                key={index}
                                className={
                                  index === 0
                                    ? 'cabTypeRow noBdr'
                                    : 'cabTypeRow'
                                }
                              >
                                <a
                                  onClick={e => {
                                    e.preventDefault();
                                    if (
                                      item.sourceCity &&
                                      item.destinationCity
                                    ) {
                                      trackClick(
                                        item.sourceCity,
                                        item.destinationCity
                                      );
                                    }
                                    let forwardDate;
                                    if (carTypeName == TEMPO_TRAVELLER) {
                                      forwardDate = 1;
                                    }
                                    getRedirectionUrl(
                                      item.redirection_url,
                                      forwardDate
                                    );
                                  }}
                                  href={item.redirection_url}
                                >
                                  <td
                                    style={{ border: '1px solid #cecece' }}
                                    className="cabTypeCol"
                                  >
                                    <p>
                                      {item.seoUrl ? (
                                        <a
                                          className="pointerEventNone cabTypeRoute"
                                          href={item.seoUrl}
                                        >
                                          {item.route}
                                        </a>
                                      ) : (
                                        <span className="cabTypeRoute">
                                          {item.route}
                                        </span>
                                      )}
                                    </p>
                                    <p className="cabTimeDis">
                                      {(() => {
                                        // if(carTypeName===TEMPO_TRAVELLER){
                                        //   return <>{item?.seat_count
                                        // ? `${item.seat_count} passengers | `
                                        // : ''}
                                        //   {item.ac_string?item.ac_string:''}
                                        // </>
                                        // }
                                        // else{
                                        return (
                                          <>
                                            {item?.oneway_distance_in_kms
                                              ? `${item.oneway_distance_in_kms} kms |`
                                              : ''}
                                            {item.oneway_duration_in_minutes
                                              ? formatDuration(
                                                  item.oneway_duration_in_minutes
                                                )
                                              : null}
                                          </>
                                        );
                                        // }
                                      })()}
                                    </p>
                                  </td>
                                  <td
                                    style={{ border: '1px solid #cecece' }}
                                    className="cabTypeCol"
                                  >
                                    <p className="cabTypeIncDis">
                                      {item.included_kms} kms included
                                    </p>
                                    <p className="cabTypeFare">
                                      Extra fare ₹{item.per_km_charge}/km after{' '}
                                      {item.included_kms} kms
                                    </p>
                                  </td>
                                  <td
                                    style={{ border: '1px solid #cecece' }}
                                    className="cabTypeCol"
                                  >
                                    {item.strike_off_amount ? (
                                      <div className="pushRight appendBottom3">
                                        <p className="strikeOffPrice">
                                          ₹{item.strike_off_amount}
                                        </p>
                                      </div>
                                    ) : null}
                                    <p className="cabTypePrice">
                                      ₹{item.total_amount}
                                    </p>
                                    <p className="cabTypeOnwards paddingT5">
                                      {item?.tolls_and_taxes_text}
                                    </p>
                                  </td>
                                </a>
                              </tr>
                              <tr>
                                {!isSSR() &&
                                item.best_price_guarantee_details ? (
                                  <td
                                    style={{ border: '1px solid #cecece' }}
                                    className="noBorder"
                                  >
                                    <BPG
                                      bpgInfo={
                                        item.best_price_guarantee_details
                                      }
                                      isMobileDevice={true}
                                      fromCity={
                                        item.sourceCity ? item.sourceCity : ''
                                      }
                                      toCity={
                                        item.destinationCity
                                          ? item.destinationCity
                                          : ''
                                      }
                                    />
                                  </td>
                                ) : null}
                              </tr>
                            </>
                          );
                        })}
                  </tbody>
                </>
              )}
            </table>
          </div>
        </div>
        {/* <>
          <div className="showMoreCabs  makeAbsolute">
            {setWidget && selectedCabType && cabs[selectedCabType].length > 0 && (
              <button
                className="showMoreCabsButton"
                onClick={() => {
                  trackTemplateEvent(
                    // omniture event for operator template only
                    `Cab_SEO_${operatorName}_${selectedCabType}_View_More_Click`
                  );
                  isMobileDevice ? setcollapsableFlag(false) : setWidget(4);
                }}
              >
                {'VIEW MORE'}
              </button>
            )}
          </div>
        </> */}
      </div>
    </section>
  );
};

export default TopCabsRoutes;
